import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', delayValue, index, SpriteFinalY }) {
  var y = SpriteFinalY;
  var finalY = y + 30;
  var animation = gsap.to(sprite, {
    pixi: { y: finalY, alpha: 0 },
    duration: duration * speed,
    delay: delayValue,
    ease: 'slow(0.3, 0.7, false)',
    paused: true,
  });
  return animation;
}
export default { Animate };
